import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
    rootAppTreeView: {
        'flexGrow': 1,
        'overflowX': 'hidden',
        // maxWidth: 300,
        '& .Mui-selected': {
            backgroundColor: '#234378 !important',
            opacity: 1,
            color: '#fff',
        },
    },
});
